import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { City } from '../domain/ot-event';
import { environment } from '../../environments/environment';
import { plainToClass } from 'class-transformer';

@Injectable({
  providedIn: 'root'
})
export class OtCityService {

  private static cityPath = '/city';
  private cityUrl: string;

  constructor(private httpClient: HttpClient) {
    this.cityUrl = environment.publicApiUrl + OtCityService.cityPath;
  }

  public findCitiesWithOtEvents(): Promise<City[]> {
    const url = this.cityUrl + '?withOtEvents';
    return this.httpClient.get(url).toPromise()
        .then(plainObject => plainToClass(City, plainObject as Object[]));
  }

  public getById(cityId: number): Promise<City> {
    const url = this.cityUrl + '/' + cityId;
    return this.httpClient.get(url).toPromise()
        .then(plainObject => plainToClass(City, plainObject));
  }
}
